import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
	standalone: false,
	selector: '[app-screenshots]',
	template: `
        <div class="dot-area">
            <div class="section-head">
                <h2 class="section-title">{{title}}</h2>
            </div>
            <div class="section-main">
                <div [dotCut]="grid">
                    <figure *ngFor="let image of images; let index = index">
                        <img [src]="image">
                    </figure>
                </div>
            </div>
        </div>
	`,
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreenshotsComponent implements OnInit {
	@HostBinding('class') hostClass = 'section screenshots';
	@Input() title: string;
	@Input() dir: string;
	@Input() format = 'png';
	@Input() grid = 6;

	images: string[];

	/**
	 * @deprecated
	 */
	@Input() captions: string[];
	@Input() count: number;

	ngOnInit(): void {
		const {dir, format} = this;

		this.images = Array.from(Array(this.count)).map((value, index) => {
			return 'assets/images/screenshots/' + dir + '/' + (index + 1) + '.' + format;
		});
	}
}
